import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GlobalLocations, RequestType, KeyValues5, LocalService, Status, PageKey } from '../../../service/local.service';
import { LocationManagementService } from '../../../service/location-management.service';
import { RequestManagementService } from '../../../service/request-management.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  globalLocations: GlobalLocations; iNumOfRecords: number = null; iSelectedTestCreation: number = 1;
  lstSectionConfigKeys: string[] = ["settings"]; txtContent = ''; isIncludeLastPaging = true; isIncludeSelected = true;

  constructor(public localService: LocalService, public configurationManagementService: ConfigurationManagementService, private locationManagementService: LocationManagementService, private languageManagementService: LanguageManagementService, private requestManagementService: RequestManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Settings);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  onLoad() {
    this.locationManagementService.getGlobalLocations().subscribe(result => {
      this.globalLocations = result;
    });
  }

  onClicked(index) {
    switch (index) {
      case 1: {
        this.configurationManagementService.backUp().subscribe(result => {
          this.localService.showMessageByStatus(result);
        });
      } break;
      case 2: {
        this.configurationManagementService.runIndexes().subscribe(result => {
          this.localService.showMessageByStatus(result);
        });
      } break;
      case 3: {
        this.configurationManagementService.generateRent().subscribe(result => {
          this.localService.showMessageByStatus(result);
        });
      } break;
      case 4: {
        this.requestManagementService.checkContentLength(this.onGetBody(), false).subscribe(result => {
          this.localService.showMessageByStatus(result.status);
        });
      } break;
      case 5: {
        this.localService.copyContent(JSON.stringify(this.onGetBody()));
      } break;
      case 6: {
        this.requestManagementService.checkContentLength(this.txtContent, true).subscribe(result => {
          this.localService.showMessageByStatus(Status.Success);
        });
      } break;
      case 7: {
        this.configurationManagementService.fixAccessRoleForPage().subscribe(result => {
          this.localService.showMessageByStatus(Status.Success);
        });
      } break;
      case 8: {
        this.configurationManagementService.ensureUniqueKeys().subscribe(result => {
          this.localService.showMessageByStatus(result);
        });
      } break;
    }
  }

  onGetBody() {
    let body = null;
    if (this.isIncludeLastPaging && this.localService.lastPageSetup && this.localService.lastPageSetup.length > 0 && this.isIncludeSelected) {
      body = {
        data: this.txtContent,
        pag: this.localService.lastPageSetup[this.localService.lastPageSetup.length - 1],
        sel: this.localService.getSelected()
      }
    } else if (this.isIncludeLastPaging && this.localService.lastPageSetup && this.localService.lastPageSetup.length > 0) {
      body = {
        data: this.txtContent,
        pag: this.localService.lastPageSetup[this.localService.lastPageSetup.length - 1]
      }
    } else if (this.isIncludeSelected) {
      body = {
        data: this.txtContent,
        sel: this.localService.getSelected()
      }
    } else {
      body = {
        data: this.txtContent
      }
    }
    return body;
  }

  onChecked(iValue) {
    this.iSelectedTestCreation = iValue;
  }

  onCreateJob() {
    switch (this.iSelectedTestCreation) {
      case 1:
      case 2:
      case 3: {
        if (this.iNumOfRecords != null && this.iNumOfRecords > 0) {
          let iNumOfRecordsTemp = this.iNumOfRecords;
          this.iNumOfRecords = null;
          this.requestManagementService.createRequest(this.iSelectedTestCreation, { v1: iNumOfRecordsTemp.toString() } as KeyValues5, this.globalLocations.selected).subscribe(result => {
            this.localService.showInformationByStatus(result);
          });
        }
      } break;
    }
  }

  onCreateTestData(requestTypeType) {
    this.requestManagementService.createTestData(requestTypeType).subscribe(result => {
      this.localService.showInformationByStatus(result);
    });
  }
}
